import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { HtmlContentService } from '../../../../services/html-content/html-content.service';
import { ActivatedRoute } from '@angular/router';
import { ReadResult } from '../../../../models/net/result/crud/read-result';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageSeverity } from '../../../../enums/message-severity';
import { HtmlContentEnvelope } from '../../../../models/net/envelope/html-content-envelope';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TelemetorComponent } from '../../../base/telemetor/telemetor.component';
import { ArticleService } from '../../../../services/articles/article.service';
import { ArticleSearchResult } from '../../../../models/net/result/article-search-result';

@Component({
    selector: 'app-html-content-viewer',
    templateUrl: './html-content-viewer.component.html',
    styleUrls: ['./html-content-viewer.component.css', '../../../../app.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class HtmlContentViewerComponent extends TelemetorComponent implements OnInit {

    private itemId: number = 0;
    private moniker: string = "";

    public itemEnvelope: HtmlContentEnvelope | undefined;
    public shareTitle: string = "Lutz Angeles";
    public shareText: string = "Home of Mendl's";

    public constructor(public appService: AppService,
                       public itemService: HtmlContentService,
                       public articleService: ArticleService,
                       public route: ActivatedRoute,
                       public sanitizer: DomSanitizer) {
        super();
    }

    public override ngOnInit(): void {

        const parameters = this.route.params;

        if (parameters != null) {

            parameters.subscribe((p) => {

                this.itemId = p["id"];

                if (this.itemId > 0) {

                    this.itemService.anonReadById(this.itemId).subscribe((r: ReadResult | null) => {

                        if (r) {

                            this.articleService.anonGetByHtmlContentId(this.itemId).subscribe((a: ArticleSearchResult | null) => {

                                if (a) {

                                    if (a.ArticleId > 0) {

                                        this.shareTitle = "Lutz Angeles Newz";
                                        this.shareText = a.Name;

                                    } else {

                                        var envelope = (r.ReadEnvelope as HtmlContentEnvelope);
                                        this.shareTitle = "Lutz Angeles";
                                        this.shareText = envelope.Document.Item.Description ?? envelope.Document.Item.Name;
                                    }

                                    this.handleReadResult(r);
                                }
                            });
                        }
                    });

                } else {

                    this.moniker = p["moniker"];

                    if (this.moniker != null && this.moniker != "") {

                        this.itemService.anonReadByMoniker(this.moniker).subscribe((r: ReadResult | null) => {

                            if (r) {

                                this.articleService.anonGetByMoniker(this.moniker).subscribe((a: ArticleSearchResult | null) => {

                                    if (a) {

                                        if (a.ArticleId > 0) {

                                            this.shareTitle = "Lutz Angeles Newz";
                                            this.shareText = a.Name;

                                        } else {

                                            var envelope = (r.ReadEnvelope as HtmlContentEnvelope);
                                            this.shareTitle = "Lutz Angeles";
                                            this.shareText = envelope.Document.Item.Description ?? envelope.Document.Item.Name;
                                        }

                                        this.handleReadResult(r);
                                    }
                                });
                            }
                        });
                    }
                }
            });
        }

        this.appService.appThemeChanged.subscribe((themeName: string) => {


        });

        this.emitTelemetrigram("load");
    }

    private handleReadResult = (r: ReadResult | null): void => {

        if (r != null) {

            if (r instanceof HttpErrorResponse) {

                this.appService.IsAppBusy = false;
                this.appService.showDialog(MessageSeverity.Error, "Error Getting " + this.itemEnvelope?.ItemTypeName, "There was an error getting " + this.itemEnvelope?.ItemTypeName + " from the server", "OK", "", true, true);

            } else if (r.IsSuccess) {

                this.itemEnvelope = new HtmlContentEnvelope(r.ReadEnvelope as HtmlContentEnvelope);

                if (!this.itemEnvelope?.Document.Item.Body) {
                    this.itemEnvelope!.Document.Item.Body = "";
                }

                this.appService.IsAppBusy = false;

            } else {

                this.appService.IsAppBusy = false;

                this.appService.showDialog(MessageSeverity.Error, "Error Reading Item", "There was an error reading item as follows " + r.Message, "OK", "", true, true);
            }
        }
    }

    public replaceThemeNameToken = (html: string | undefined): SafeHtml => {

        let result: SafeHtml = "";

        const themeName = this.appService.themeService.currentThemeName;
        const invertFilter = themeName === 'dark' ? 'invert(100%)' : 'invert(0%)';

        let themeReplacedHtml = html?.replace(/\{themeName\}/g, themeName).replace(/\{themeImageInversionFilter\}/g, invertFilter);

        if (themeReplacedHtml) {

            result = this.sanitizer.bypassSecurityTrustHtml(themeReplacedHtml);
        }

        return result;
    }

    public share = (): void => {

        const telemetrigramOperation: string = "share:" + this.shareTitle + ";" + this.shareText;
        this.appService.share(this.shareTitle, this.shareText);

        this.emitTelemetrigram(telemetrigramOperation.substring(0, 100));
    }
}
